






































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/renderer/cmp-clickable-cell-renderer.vue"
}
